export default [
  {
    path: '/sales/new-sale',
    name: 'new-sales',
    component: () => import('../pages/sales/new-sale/product-search.shell.vue'),
  },
  {
    path: '/sales/booking-form',
    name: 'booking-form',
    component: () => import('../pages/sales/booking-form/booking-form.shell.vue'),
  },
  {
    path: '/sales/payments/:id',
    name: 'payments',
    component: () => import('../pages/sales/payments/payments.shell.vue'),
  },
  {
    path: '/sales/payments/:id/:balancePaymentId',
    name: 'payments-with-balance',
    component: () => import('../pages/sales/payments/payments.shell.vue'),
  },
  {
    path: '/sales/daily-sales',
    name: 'daily-sales',
    component: () => import('../pages/sales/daily-sales/daily-sales.shell.vue'),
  },
  {
    path: '/sales/order-documents/:id',
    name: 'order-documents',
    component: () => import('../pages/sales/order-documents/order-documents.shell.vue'),
  },
];
